(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-souk-tier1]').forEach((section) => {
      if (section.dataset.soukTier1Ready) return;
      section.dataset.soukTier1Ready = 'true';
      const proof = section.querySelector('[data-souk-review-proof]');
      const reviews = section.querySelector('[data-yotpo-single-source][data-review-widget-product-id]');
      const stars = proof?.querySelector('[data-souk-proof-stars]');
      const ratingText = proof?.querySelector('[data-souk-proof-rating]');
      const countText = proof?.querySelector('[data-souk-proof-count]');

      if (proof && reviews && stars && ratingText && countText && reviews.dataset.reviewWidgetProductId === section.dataset.productId) {
        let frame;
        const sync = () => {
          const text = reviews.innerText.replace(/\s+/g, ' ').trim();
          const match = text.match(/Customer Reviews\s+([0-5](?:\.\d+)?)\s+Based on\s+([\d,]+)\s+reviews?/i);
          const rating = match ? Number(match[1]) : NaN;
          const count = match ? Number(match[2].replace(/,/g, '')) : 0;
          const loaded = Number.isFinite(rating) && rating >= 0 && rating <= 5 && Number.isSafeInteger(count) && count > 0;
          stars.hidden = !loaded;
          ratingText.hidden = !loaded;
          if (loaded) {
            stars.style.setProperty('--otp-souk-rating-fill', `${rating / 5 * 100}%`);
            ratingText.textContent = `${rating.toFixed(1)} / 5`;
            countText.textContent = `${count.toLocaleString()} ${count === 1 ? 'review' : 'reviews'}`;
            proof.setAttribute('aria-label', `${rating.toFixed(1)} out of 5 stars from ${count} ${count === 1 ? 'review' : 'reviews'}. Read customer reviews.`);
          } else {
            ratingText.textContent = '';
            countText.textContent = 'Read reviews';
            proof.setAttribute('aria-label', proof.dataset.reviewFallback || 'Read reviews for Souk Honey');
          }
        };
        const observer = new MutationObserver(() => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        });
        observer.observe(reviews, { childList: true, characterData: true, subtree: true });
        sync();
      }

      section.querySelectorAll('[data-souk-detail-link]').forEach((link) => {
        link.addEventListener('click', () => {
          const target = document.getElementById(link.hash.slice(1));
          if (target?.tagName !== 'DETAILS') return;
          target.open = true;
          target.querySelector('summary')?.focus({ preventScroll: true });
        });
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
